/**
 * Central company details — single source of truth for legal/branding copy.
 *
 * Brand/trading name is "OnSiteHand". Legal company name is "ONSITEHAND LIMITED".
 * Do NOT edit individual legal pages for these details — update this file, then
 * the footer / legal pages / contact page / email footers will all follow.
 */

export const COMPANY = {
  tradingName: 'OnSiteHand',
  legalName: 'ONSITEHAND LIMITED',
  companyNumber: '17186065',
  companyType: 'Private limited company',
  registeredIn: 'England and Wales',
  registeredOffice: 'Unit A449, 4-6 Greatorex Street, London, E1 5NF, United Kingdom',
  website: 'onsitehand.co.uk',
};

/** Long legal block used in full footers and contracts. */
export const COMPANY_LEGAL_FOOTER_LONG = (
  `${COMPANY.tradingName} is a trading name of ${COMPANY.legalName}. ` +
  `${COMPANY.legalName} is a private limited company registered in ${COMPANY.registeredIn}. ` +
  `Company number: ${COMPANY.companyNumber}. ` +
  `Registered office: ${COMPANY.registeredOffice}.`
);

/** Shorter one-liner for mobile footers and email signatures. */
export const COMPANY_LEGAL_FOOTER_SHORT = (
  `${COMPANY.legalName} is registered in ${COMPANY.registeredIn}. ` +
  `Company number: ${COMPANY.companyNumber}. ` +
  `Registered office: ${COMPANY.registeredOffice}.`
);

/** Registered office note — avoids it looking like a walk-in support address. */
export const REGISTERED_OFFICE_NOTE =
  'Registered office only. Please contact us online for support.';

/** Copyright line — current year substituted at render time. */
export const copyrightLine = (year = new Date().getFullYear()) =>
  `© ${year} ${COMPANY.legalName}. All rights reserved.`;
